export const FLYER_URL =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_2abc6504-56b2-4fac-a384-077a9f695e69/artifacts/80cezv8d_Arcipelago.jpg";

export const scrollToId = (id) => {
  const target = `#${id}`;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -72, duration: 1.4 });
  } else {
    document.querySelector(target)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const PERCORSO_OPTIONS = [
  { value: "gruppo_presenza", label: "Gruppo in presenza", detail: "Lugano Paradiso" },
  { value: "gruppo_online", label: "Gruppo online", detail: "Max 5 partecipanti" },
  { value: "individuale", label: "Percorso individuale", detail: "In presenza o online" },
];

export const DIAGNOSI_OPTIONS = [
  { value: "si", label: "Sì" },
  { value: "no", label: "No" },
  { value: "in_valutazione", label: "In fase di valutazione" },
];

export const CICLO_OPTIONS = [
  { value: "ciclo_1", label: "Primo ciclo", detail: "Gennaio – Giugno 2027" },
  { value: "ciclo_2", label: "Secondo ciclo", detail: "Luglio – Dicembre 2027" },
];

export const cicloLabel = (v) => CICLO_OPTIONS.find((o) => o.value === v)?.label || v;

export const INCONTRI = [
  {
    num: "01",
    title: "ADHD: miti e realtà",
    short: "Miti e Realtà",
    desc: "Si parte smontando i luoghi comuni: l'ADHD adulto non è distrazione da bambini né mancanza di volontà. Esploriamo come funziona davvero il cervello ADHD, cosa dice la ricerca sulle neurodiversità e come riconoscere il proprio funzionamento unico — con i suoi punti di forza, non solo le difficoltà.",
    date: "Mercoledì 3 Giugno 2026",
    time: "17:00 – 18:30",
  },
  {
    num: "02",
    title: "Trattamenti dell'ADHD",
    short: "Trattamenti",
    desc: "Una mappa chiara e onesta delle strade possibili: psicoeducazione, strategie comportamentali, percorso farmacologico, mindfulness e tecniche di autoregolazione. Cosa funziona, per chi, e come costruire un piano multimodale su misura invece di cercare la soluzione unica che non esiste.",
    date: "Mercoledì 1 Luglio 2026",
    time: "17:00 – 18:30",
  },
  {
    num: "03",
    title: "Organizzazione del tempo",
    short: "Tempo",
    desc: "La «cecità temporale» è una delle firme dell'ADHD adulto. Lavoriamo su strumenti concreti: pianificazione realistica, promemoria esterni, gestione delle scadenze, superamento della procrastinazione e trucchi per rendere il tempo visibile e alleato invece che nemico.",
    date: "Mercoledì 5 Agosto 2026",
    time: "17:00 – 18:30",
  },
  {
    num: "04",
    title: "Gestione dello spazio",
    short: "Spazio",
    desc: "L'ambiente attorno a noi parla alla nostra attenzione. Impariamo a progettare spazi fisici e digitali funzionali e anti-distrazione: decluttering strategico, sistemi semplici per ritrovare le cose, riduzione del sovraccarico cognitivo a casa e al lavoro.",
    date: "Mercoledì 2 Settembre 2026",
    time: "17:00 – 18:30",
  },
  {
    num: "05",
    title: "Relazioni interpersonali",
    short: "Relazioni",
    desc: "Impulsività verbale, sensibilità al rifiuto, emozioni che arrivano forte e subito: l'ADHD attraversa anche i rapporti. Parliamo di comunicazione, regolazione emotiva, confini sani e di come spiegare il proprio funzionamento a famiglia, amici e colleghi.",
    date: "Mercoledì 7 Ottobre 2026",
    time: "17:00 – 18:30",
  },
  {
    num: "06",
    title: "Cura di sé e autostima",
    short: "Cura di Sé",
    desc: "Anni di «non sei abbastanza» lasciano il segno. Chiudiamo il percorso ricostruendo: autocompassione, prevenzione del burnout, sonno e routines sostenibili, e un'identità adulta con ADHD di cui non doversi scusare — ma da abitare con consapevolezza.",
    date: "Mercoledì 4 Novembre 2026",
    time: "17:00 – 18:30",
  },
];

export const CALENDARIO_FALLBACK = INCONTRI.map((it, idx) => ({
  id: `static-${idx + 1}`,
  anno: 2026,
  numero: idx + 1,
  titolo: it.title,
  data: it.date,
  ora: it.time,
}));

export const CONTATTI = {
  studio: "Dr. med. Nicolò Pipitone",
  indirizzo: "Via Generale Guisan 8B, 6900 Lugano Paradiso",
  email: "pipitone@hin.ch",
};
